/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1addee8e"]'><div :class='["modal-with-vertical-icon-demo"]'><cube-modal ref="__mpx_ref_modal__" type="confirm" title="我是标题哟我是标题哟我是标题哟~" content="我是正文我是正文我是正文~" close-text="取消" confirm-btn="确认" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'><div slot="icon"><mpx-image src="https://ut-static.udache.com/webx/mpx-cube-ui/06UBoCw3t0hVzCurBpcKs.png" :class='["modal-image-icon"]'></mpx-image></div></cube-modal><cube-button @_click="onTap">modal-with-vertical-icon</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_1addee8e"}'>
.modal-with-vertical-icon-demo
  .modal-image-icon
    display block
    height 80px
    width 80px
    margin-left auto
    margin-right auto
    margin-bottom 15px
    border-radius 50%
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1addee8e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1addee8e"}
  /** script content **/
  require("./modal-with-vertical-icon.mpx.js?isComponent&outputPath=components%2Fmodal-with-vertical-icon1addee8e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-with-vertical-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-with-vertical-icon1addee8e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1addee8e"],
    ctorType: "component",
    outputPath: "components/modal-with-vertical-icon1addee8e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>